import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DatePipe, NgClass, TitleCasePipe } from '@angular/common';
import { EmptyResultComponent } from '@shared/components/empty-result/empty-result.component';
import {
  Apartment,
  RenterInformation,
} from '@modules/universal-billing/apartments/apartments.interface';
import { ModalService } from '@shared/services/modal/modal.service';
import {
  RenterAssignComponent
} from '@modules/universal-billing/apartments/apartment-profile/renter-information/renter-assign/renter-assign.component';
import {
  RenterWithdrawComponent
} from '@modules/universal-billing/apartments/apartment-profile/renter-information/renter-withdraw/renter-withdraw.component';
import { ModalClose } from '@shared/services/modal/modal.enum';
import { environment } from '@environments/environment.prod';

@Component({
  selector: 'renter-information',
  standalone: true,
  imports: [
    TranslatePipe,
    NgClass,
    TitleCasePipe,
    DatePipe,
    EmptyResultComponent
  ],
  templateUrl: './renter-information.component.html',
  styleUrl: './renter-information.component.scss'
})
export class RenterInformationComponent {
  @Input({required: true}) renterInformation: RenterInformation;
  @Input() apartment: Apartment;
  @Output() reload = new EventEmitter();

  modalService = inject(ModalService);

  protected readonly environment = environment;


  withdraw() {
    this.modalService.open({
      component: RenterWithdrawComponent,
      title: 'RESIDENTS.WITHDRAW',
      componentOptions: {
        apartmentId: this.apartment?.id,
        renterId: this.apartment?.renter?.id
      },
      modalOptions: {
        scrollable: false
      }
    }).then(res => {
      if (res === ModalClose.SUCCESS) {
        this.reload.emit();
      }
    })
  }

  assign() {
    this.modalService.open({
      component: RenterAssignComponent,
      title: 'RESIDENTS.ASSIGN',
      modalOptions: {
        scrollable: true,
        size: "xl"
      },
      componentOptions: {
        apartment: this.apartment
      }
    }).then(res => {
      if (res === ModalClose.SUCCESS) {
        this.reload.emit();
      }
    })
  }
}
